import { useEffect } from "react";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  BLUR_COMMAND,
  COMMAND_PRIORITY_LOW,
  FOCUS_COMMAND,
  LexicalEditor,
} from "lexical";

export default function RefPlugin({
  onRef,
  onFocus,
  onBlur,
}: {
  onRef: (_editor: LexicalEditor) => void;
  onFocus?: () => void;
  onBlur?: () => void;
}) {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    onRef(editor);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editor]);

  useEffect(
    () =>
      editor.registerCommand(
        BLUR_COMMAND,
        () => {
          onBlur?.();
          return false;
        },
        COMMAND_PRIORITY_LOW
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(
    () =>
      editor.registerCommand(
        FOCUS_COMMAND,
        () => {
          onFocus?.();
          return false;
        },
        COMMAND_PRIORITY_LOW
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return null;
}
